module.exports = __webpack_public_path__ + "img/Baselogin.77997522.jpg";